const _ = window._; // TODO: Replace with import once all services are being imported instead of using window.cirkulServices
const $ = window.$; // TEMPORARY. REMOVE JQUERY WHEN POSSIBLE.

console.log('[2024-10-14] checkout init');

// TODO: Remove IIFE, export hook that returns reactive state and callable functions.
(() => {
  const FREE_GIFT_REDEMPTION_KEY_PROPERTY = '_free_gift_redemption_key';
  const FREE_GIFT_TRACKING_PROPERTY = '_free_gift_tracking';
  const FREE_GIFT_MINIMUM_CART_TOTAL_PROPERTY = '_free_gift_minimum_cart_total';
  const FREE_GIFT_MINIMUM_CART_FULL_PRICE_SIPS_COUNT_PROPERTY = '_free_gift_minimum_cart_full_price_sips_count';

  const GIFT_CODES_CART_ATTRIBUTE = '__gift_codes';

  const CHECKOUT_API_LOCATION = '/apps/checkout';
  const FREE_GIFTS_KEY_LOCAL_VARIABLE = 'cirkul::checkout::free-gifts-key';
  const GIFT_CODES_LOCAL_VARIABLE = 'cirkul::checkout::gift-codes';

  const GIFT_CODE_URL_PARAMETER = 'gftcd';

  const GIFT_CODES_MAP = {
    'WWDD721': {
      code: 'JUL2021_WW_DREAM_DRAW',
      toastDescription: 'A free Fruit Punch Sip',
    },
    'OIM721': {
      code: 'NOV2023_EMAIL_POPUP_LIFESIP_FRUIT_PUNCH',
      toastDescription: 'A free Fruit Punch Sip',
    },
    'BOTL921': {
      code: 'SEP2021_PB22_LID',
      toastDescription: 'A free 22oz. Plastic Bottle and Lid',
    },
    'CHILL921': {
      code: 'SEP2021_BLUE_22OZ_CHILL_SLEEVE',
      toastDescription: 'A free Blue Chill Sleeve',
    },
    'FITMB921': {
      code: 'SEP2021_FITMB',
      toastDescription: 'A free Mixed Berry Sip',
    },
    'FWCLWM122': {
      code: 'JAN2022_FITWC_LIFEWM',
      toastDescription: 'A free White Cherry Sip and Watermelon Sip'
    },
    'FWCLWM122NM': {
      code: 'JAN2022_FITWC_LIFEWM_NO_MINIMUM',
      toastDescription: 'A free White Cherry Sip and Watermelon Sip'
    },
    'LFPFMB722': {
      code: 'JUL2022_LIFEFP_FITMB',
      toastDescription: 'A free Fruit Punch Sip and Mixed Berry Sip'
    },
    'BOTLLFP722': {
      code: 'JUL2022_PB22_LID_LIFEFP',
      toastDescription: 'A free 22oz. Plastic Bottle, Lid, and Fruit Punch Sip'
    },
    'POPGWY1122': {
      code: 'NOV2022_EMAIL_POPUP_GATEWAY_TEA',
      toastDescription: 'A free Sweet Tea Sip',
    },
    'POPFIS1122': {
      code: 'NOV2022_EMAIL_POPUP_FISSION',
      toastDescription: 'A free Jackpot (Green Apple) Sip',
    },
    'POPSQZ1122': {
      code: 'NOV2022_EMAIL_POPUP_SQUEEZE',
      toastDescription: 'A free Raspberry Lemonade Sip',
    },
    'POPSTG1122': {
      code: 'NOV2022_EMAIL_POPUP_STAGE',
      toastDescription: 'A free Strawberry Watermelon Sip',
    },
    'POPFLY1122': {
      code: 'NOV2022_EMAIL_POPUP_FLYTE',
      toastDescription: 'A free Last Drive (Blue Raspberry) Sip',
    },
    'POPVER1122': {
      code: 'NOV2022_EMAIL_POPUP_VERDA',
      toastDescription: 'A free Watermelon Sip',
    },
    'FLDLHCA623': {
      code: 'JUN2023_FLYLSTDRV_LIFEHCA',
      toastDescription: 'A free Last Drive (Blue Raspberry) Sip and Honeycrisp Apple Sip'
    },
    'LANDGWYSWTTEA623': {
      code: 'JUN2023_LANDING_GATEWAY_SWTTEA',
      toastDescription: 'A free Sweet Tea Sip'
    },
    'LANDGWYTEABLC623': {
      code: 'JUN2023_LANDING_GATEWAY_TEABLC',
      toastDescription: 'A free Blackberry Tea Sip'
    },
    'LANDGWYGRNTEA623': {
      code: 'JUN2023_LANDING_GATEWAY_GRNTEA',
      toastDescription: 'A free Green Tea Sip'
    },
    'LANDGWYTEALEM623': {
      code: 'JUN2023_LANDING_GATEWAY_TEALEM',
      toastDescription: 'A free Tea and Lemonade Sip'
    },
    'LANDGWYTEARSP623': {
      code: 'JUN2023_LANDING_GATEWAY_TEARSP',
      toastDescription: 'A free Raspberry Tea Sip'
    },
    'LANDGWYTEAPCH623': {
      code: 'JUN2023_LANDING_GATEWAY_TEAPCH',
      toastDescription: 'A free Peach Tea Sip'
    },
    //
    'POPLIFP1123': {
      code: 'NOV2023_EMAIL_POPUP_LIFESIP_FRUIT_PUNCH',
      toastDescription: 'A free Fruit Punch Sip'
    },
    'POPGOBR1123': {
      code: 'NOV2023_EMAIL_POPUP_GOSIP_BLUE_RASPBERRY',
      toastDescription: 'A free Blue Raspberry Sip'
    },
    'POPGWTEAPCH1123': {
      code: 'NOV2023_EMAIL_POPUP_GATEWAY_TEAPCH',
      toastDescription: 'A free Peach Tea Sip'
    },
    'POPFLHS1123': {
      code: 'NOV2023_EMAIL_POPUP_FLYTE_HIT_STICK',
      toastDescription: 'A free Hit Stick Sip'
    },
    'POPIEPFDF1123': {
      code: 'NOV2023_EMAIL_POPUP_INFLOW_PASSION_FRUIT_DRAGON_FRUIT',
      toastDescription: 'A free Passion Fruit Dragon Fruit Sip'
    },
    'POPIEBLC1123': {
      code: 'NOV2023_EMAIL_POPUP_INFLOW_BLACKBERRY',
      toastDescription: 'A free Blackberry Sip'
    },
    'POPSABSTR1123': {
      code: 'NOV2023_EMAIL_POPUP_SABROCITA_STRAWBERRY',
      toastDescription: 'A free Strawberry Sip'
    },
    'POPSABSOURSP1123': {
      code: 'NOV2023_EMAIL_POPUP_SABROCITA_SOURSOP',
      toastDescription: 'A free Soursop Sip'
    },
    'POPWSPRPNCH0424': {
      code: 'APR2024_EMAIL_POPUP_WILD_SPLASH_PARROT_PUNCH',
      toastDescription: 'A free Wild Splash Parrot Punch Sip'
    },
    'POPWSWALWTR0424': {
      code: 'APR2024_EMAIL_POPUP_WILD_SPLASH_WALRUS_WATERMELON',
      toastDescription: 'A free Wild Splash Walrus Watermelon Sip'
    },
    'POPWSSHKSTR0424': {
      code: 'APR2024_EMAIL_POPUP_WILD_SPLASH_SHARK_STRAWBERRY',
      toastDescription: 'A free Wild Splash Shark Strawberry Sip'
    },
    'POPWSCHTCHR0424': {
      code: 'APR2024_EMAIL_POPUP_WILD_SPLASH_CHEETAH_CHERRY',
      toastDescription: 'A free Wild Splash Cheetah Cherry Sip'
    },
    'POPWSGCKGRP0424': {
      code: 'APR2024_EMAIL_POPUP_WILD_SPLASH_GECKO_GRAPE',
      toastDescription: 'A free Wild Splash Gecko Grape Sip'
    },
    'POPWSBERBRY0424': {
      code: 'APR2024_EMAIL_POPUP_WILD_SPLASH_BEAR_BERRY',
      toastDescription: 'A free Wild Splash Bear Berry Sip'
    },
    // These differ from the ones above in that they have no cart minimum, are intended for return customers.
    'RETURNLANDGWYSWTTEA623': {
      code: 'JUN2023_RETURN_LANDING_GATEWAY_SWTTEA',
      toastDescription: 'A free Sweet Tea Sip'
    },
    'RETURNLANDGWYTEABLC623': {
      code: 'JUN2023_RETURN_LANDING_GATEWAY_TEABLC',
      toastDescription: 'A free Blackberry Tea Sip'
    },
    'RETURNLANDGWYGRNTEA623': {
      code: 'JUN2023_RETURN_LANDING_GATEWAY_GRNTEA',
      toastDescription: 'A free Green Tea Sip'
    },
    'RETURNLANDGWYTEALEM623': {
      code: 'JUN2023_RETURN_LANDING_GATEWAY_TEALEM',
      toastDescription: 'A free Tea and Lemonade Sip'
    },
    'RETURNLANDGWYTEARSP623': {
      code: 'JUN2023_RETURN_LANDING_GATEWAY_TEARSP',
      toastDescription: 'A free Raspberry Tea Sip'
    },
    'RETURNLANDGWYTEAPCH623': {
      code: 'JUN2023_RETURN_LANDING_GATEWAY_TEAPCH',
      toastDescription: 'A free Peach Tea Sip'
    },
    'MB22WHT1223': {
      code: 'DEC2023_MB22_LID',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid',
    },
    'MB22WHTFO1223': {
      code: 'DEC2023_MB22_LID_FIRST_ONLY',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid',
    },
    'MB22WHT0224': {
      code: 'FEB2024_MB22_LID',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid',
    },
    'BOTL0224': {
      code: 'FEB2024_PB22_LID',
      toastDescription: 'A free 22oz. Plastic Bottle and Blue Lid',
    },
    'NIFT0224': {
      code: 'FEB2024_NIFT_MB22_LIFEHCA_FITILPNCH',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid, Honeycrisp Apple Sip, and Island Punch Sip',
    },
    // 'STRAWBERRY0224': { // Expired 12:01am 2024-03-01
    //   code: 'FEB2024_NATIONAL_STRAWBERRY_DAY',
    //   toastDescription: 'A free Sabrocita Strawberry (Fresa) Sip'
    // },
    // 'LEAP0224': { // Expired 12:01am 2024-03-03
    //   code: 'FEB2024_LEAP_DAY',
    //   toastDescription: 'A free GoSip Blue Raspberry Sip'
    // },
    'FLDLHCA0224': {
      code: 'FEB2024_FLYLSTDRV_LIFEHCA',
      toastDescription: 'A free Flyte Last Drive (Blue Raspberry) Sip and LifeSip Honeycrisp Apple Sip'
    },
    'GRTSSL0224': {
      code: 'FEB2024_GWYTEARSP_SQZSTRLEM',
      toastDescription: 'A free Gateway Raspberry Tea Sip and Squeeze Strawberry Lemonade Sip'
    },
    'LSKFMB0224': {
      code: 'FEB2024_LIFESTRKWI_FITMB',
      toastDescription: 'A free LifeSip Strawberry Kiwi Sip and FitSip Mixed Berry Sip'
    },
    'SMS0224': {
      code: 'FEB2024_SMS_LIFEHCA',
      toastDescription: 'A free LifeSip Honeycrisp Apple Sip'
    },
    'REF4CARTA0324': {
      code: 'MAR2024_REFERRAL_4CART_A',
      toastDescription: 'Your four free Sips',
    },
    'REF4CARTB0324': {
      code: 'MAR2024_REFERRAL_4CART_B',
      toastDescription: 'Your four free Sips',
    },
    'USASWIM2024': {
      code: 'MAR2024_USASWIM_LIFESTRKWI_FITMB',
      toastDescription: 'A free LifeSip Strawberry Kiwi Sip and FitSip Mixed Berry Sip'
    },
    'LEAD4CARTA0324': {
      code: 'MAR2024_LEAD_4CART_A',
      toastDescription: 'Your four free Sips',
    },
    'LEAD2CARTA0324': {
      code: 'MAR2024_LEAD_2CART_A',
      toastDescription: 'A free LifeSip Fruit Punch Sip and FitSip Mixed Berry Sip'
    },
    'REF2CARTA0324': {
      code: 'MAR2024_REFERRAL_2CART_A',
      toastDescription: 'A free LifeSip Fruit Punch Sip and FitSip Mixed Berry Sip'
    },
    'REFMB220324': {
      code: 'MAR2024_REFERRAL_MB22_LID',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid'
    },
    // 'STPAT0324': { // Expired 12:01am 2024-03-20
    //   code: 'MAR2024_ST_PATRICKS_DAY_LIFESTRKWI',
    //   toastDescription: 'A free LifeSip Strawberry Kiwi Sip'
    // },
    'NC0324': {
      code: 'MAR2024_LEAD_LIFESTRKWI_FITMB',
      toastDescription: 'A free LifeSip Strawberry Kiwi Sip and FitSip Mixed Berry Sip'
    },
    'WMB-PP120424': {
      code: 'APR2024_MB22_LID_PP12',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid',
    },
    'WMB-ARC0424': {
      code: 'APR2024_MB22_LID_ARC',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid',
    },
    'WMB-LPD0424': {
      code: 'APR2024_MB22_LID_LPD',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid',
    },
    'TENSIP0424': {
      code: 'APR2024_TENSIP_MB22_LID',
      toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid',
    },
    '4SIPS0624': {
      code: 'JUNE2024_EVERGREEN_4SIPS',
      toastDescription: 'Your four free Sips'
    },
    'ICEDTEA0624': {
      code: 'JUN2024_ICED_TEA_DAY_GWYTEABLC',
      toastDescription: 'A free Gateway Blackberry Tea Sip'
    },
    // 'MRBEAST0624': {
    //   code: 'JUN2024_MRBEAST_MB22_LID',
    //   toastDescription: 'A free 22oz. White Stainless Steel Bottle and Blue Lid'
    // },
    'FILT0724': {
      code: 'JUL2024_FILT',
      toastDescription: 'A free Cirkul Flow Filter',
    },
    'PB220724': {
      code: 'JUL2024_PB22_LID',
      toastDescription: 'A free 22oz. Plastic Bottle and Blue Lid',
    },
    'PB120724': {
      code: 'JUL2024_PB12_LID',
      toastDescription: 'A free 12oz. Plastic Bottle and Blue Lid',
    },
    // 'GWYSWTTEA0824': {
    //   code: 'AUG2024_LAPSED_CUSTOMER_GWYSWTTEA', // Expires 8/30 @ 3am ET
    //   toastDescription: 'A free Gateway Sweet Tea Sip'
    // },
    // 'FILT1124': { // Expires 3:01am ET 2024-11-05
    //   code: 'NOV2024_FILT',
    //   toastDescription: 'A free Cirkul Flow Filter',
    // },
    'BIGGAME0225': { // Expires 3:01am ET 2025-03-03
      code: 'FEB2025_BIGGAME_LIFEFP',
      toastDescription: 'A free LifeSip Fruit Punch Sip',
    },
    'POPPB22LID0225': {
      code: 'FEB2025_EMAIL_POPUP_22OZ_PLASTIC_BOTTLE_25MIN',
      toastDescription: 'A free 22oz. Plastic Bottle and Blue Lid',
    },
    'POP3PACK0225': {
      code: 'FEB2025_EMAIL_POPUP_3PACK_SIPS_25MIN',
      toastDescription: 'A free LifeSip Fruit Punch Sip, GoSip Black Cherry Sip, and FitSip Mixed Berry Sip',
    },
  };

  let giftCodes = [];
  let freeGifts = [];
  let freeGiftValidationInterval = null;

  _initService();

  window.cirkulServices = window.cirkulServices || {};
  window.cirkulServices.checkout = {
    addGiftCode: addGiftCode,
    applyFreeGiftsToCart: applyFreeGiftsToCart,
    checkGiftCodeAppliedToCart: checkGiftCodeAppliedToCart,
    completeCheckout: completeCheckout,
  };
  window.resolveCirkulServices.checkout();

  function _initService() {
    // Load current gift codes, check for new ones in URL
    giftCodes = JSON.parse(localStorage.getItem(GIFT_CODES_LOCAL_VARIABLE) || '[]');

    const queryParamGiftCode = getParameterByName(GIFT_CODE_URL_PARAMETER);
    if (queryParamGiftCode) {
      addGiftCode(queryParamGiftCode);
    }
  }

  function addGiftCode(giftShortcode, toastImageUrl, skipToast) {
    const newGiftCode = GIFT_CODES_MAP[giftShortcode];

    console.log('MARCTEST ADDING GIFT CODE', giftShortcode, newGiftCode);

    if (newGiftCode) {
      giftCodes = _.union(giftCodes, [newGiftCode.code]); // prevent duplicates by using union
      localStorage.setItem(GIFT_CODES_LOCAL_VARIABLE, JSON.stringify(giftCodes));
      _setCartGiftCodesAttribute(giftCodes);

      _notify();
    }

    function _notify() {
      if (!window.toastr) {
        setTimeout(_notify, 250);
        return;
      }

      if (skipToast) {
        return;
      }

      if (toastImageUrl) {
        window.toastr.success(`
          ${newGiftCode.toastDescription} will be added to your cart at checkout
          <img src="${toastImageUrl}" style="background: white; border-radius: 10px; margin: .5rem 0; display: block; height: 120px;"/>
        `, null, {
          positionClass: 'toast-top-center', timeOut: 10000, extendedTimeOut: 10000
        });
      } else {
        window.toastr.success(`${newGiftCode.toastDescription} will be added to your cart at checkout`, null, {
          positionClass: 'toast-top-center', timeOut: 10000, extendedTimeOut: 10000
        });
      }
    }
  }

  function applyFreeGiftsToCart(shopifyCustomerId) {
    let redemptionKey = localStorage.getItem(FREE_GIFTS_KEY_LOCAL_VARIABLE) || null;
    let cartChanged = false;
    let cartTotal = 0;
    let cartFullPriceSipsCount = 0;

    if (!shopifyCustomerId && giftCodes.length < 1) {
      return Promise.resolve()
        .then(_replaceFreeGiftsInCart)
        .catch(() => { }) // Errors should not prevent cart or checkout page from operating as usual
        .then(() => { return cartChanged; })
        ;
    } else {
      return Promise.resolve()
        .then(_getCurrentCartTotal)
        .then(_getFreeGifts)
        .then(_replaceFreeGiftsInCart)
        .catch(() => { }) // Errors should not prevent cart or checkout page from operating as usual
        .then(() => { return cartChanged; });
    }

    function _getCurrentCartTotal() {
      return new Promise((resolve, reject) => {
        $.get('/cart.json').done((cartJson) => {
          const cartResponse = typeof cartJson === 'object' ? cartJson : JSON.parse(cartJson); // cartJson seems to sometimes parse automatically and sometimes not.

          cartTotal = cartResponse.items_subtotal_price;

          _.forEach(cartResponse.items, (cartItem) => {
            if (cartItem.product_type === 'Gift Card') {
              cartTotal -= cartItem.line_price;
            }

            if (_.startsWith(cartItem.sku, '1PK')) {
              cartFullPriceSipsCount += cartItem.quantity;
            }
          });

          resolve();
        }).fail(reject);
      });
    }

    function _getFreeGifts() {
      console.log('MARCTEST GETTING FREE GIFTS');
      return new Promise((resolve, reject) => {
        $.ajax({
          type: 'get',
          url: `${CHECKOUT_API_LOCATION}/checkout/gifts`,
          data: {
            id: shopifyCustomerId,
            redeem: false,
            key: redemptionKey,
            codes: giftCodes,
            cartTotal: _.includes(window.location.pathname, 'checkout') ? cartTotal : 99999, // Bypass cartTotal check if not actually in checkout
            cartFullPriceSipsCount: _.includes(window.location.pathname, 'checkout') ? cartFullPriceSipsCount : 99999, // Bypass cartFullPriceSipsCount check if not actually in checkout
            context: null,
          },
        }).done((response) => {
          console.log('MARCTEST RESPONSE', response);
          freeGifts = response.data.gifts;
          redemptionKey = response.data.key;
          let invalidCodes = response.data.invalidCodes;

          if (redemptionKey) {
            localStorage.setItem(FREE_GIFTS_KEY_LOCAL_VARIABLE, redemptionKey);
          } else {
            localStorage.removeItem(FREE_GIFTS_KEY_LOCAL_VARIABLE);
          }

          if (invalidCodes && invalidCodes.length) {
            // console.log('MARCTEST - Removing invalid codes', invalidCodes);
            giftCodes = _.difference(giftCodes, invalidCodes); // stop trying to use gift codes that aren't valid
            localStorage.setItem(GIFT_CODES_LOCAL_VARIABLE, JSON.stringify(giftCodes));
            _setCartGiftCodesAttribute(giftCodes);
          }

          resolve();
        }).fail(() => {
          freeGifts = [];

          resolve();
        });
      });
    }

    function _replaceFreeGiftsInCart() {
      console.log('MARCTEST REPLACING FREE GIFTS');
      let previousCxGiftItems = [];
      let hasNonCxGiftItems = false;

      return new Promise((resolve, reject) => {
        $.get('/cart.json').done((cartJson) => {
          const cartResponse = typeof cartJson === 'object' ? cartJson : JSON.parse(cartJson); // cartJson seems to sometimes parse automatically and sometimes not.

          previousCxGiftItems = _.filter(cartResponse.items, function (item) {
            //return item.product_type === 'CX Gift' && !item.properties.lander_incentive && !item.properties._lander_incentive
            return (
              item.product_type === 'CX Gift' && !item.properties.lander_incentive && !item.properties._lander_incentive) || 
              (item.sku === 'IMB22WHTLIDWHTBLUGSK') || 
              (item.sku === 'IPB22LIDWHTBLU') ||
              (item.sku === 'IPB12LIDWHTBLU') ||
              (item.sku === 'I3PKLIFEFPGOBCFITMB')
          });
          hasNonCxGiftItems = true; // Currently not required, but if needed, change to: cartResponse.items.length > previousCxGiftItems.length;

          // CX Shipping is a different product type, look for the specific SKU instead
          const previousCxShippingItems = _.filter(cartResponse.items, { sku: 'CXSHIPUSPS5' });
          previousCxGiftItems = _.concat(previousCxGiftItems, previousCxShippingItems);

          const cartRequiresUpdate = _checkCartNeedsUpdating();

          if (cartRequiresUpdate) {
            Promise.resolve()
              .then(_removeGiftItemsFromCart)
              .then(_addGiftItemsToCart)
              .then(resolve)
              .catch(reject);
          } else if (previousCxGiftItems.length && !hasNonCxGiftItems) {
            Promise.resolve()
              .then(_removeGiftItemsFromCart)
              .then(resolve)
              .catch(reject);
          } else {
            resolve();
          }


        }).fail(reject);
      });

      function _removeGiftItemsFromCart() {
        if (!previousCxGiftItems.length) {
          return;
        }

        console.log('MARCTEST REMOVE FROM CART');

        cartChanged = true;

        const removeItemCartUpdates = {};

        _.forEach(previousCxGiftItems, (cartItem) => {
          removeItemCartUpdates[cartItem.key] = 0;
        });

        return new Promise((resolve, reject) => {
          $.ajax({
            data: {
              updates: removeItemCartUpdates,
            },
            dataType: 'json',
            type: 'POST',
            url: '/cart/update.js',
          }).done(resolve)
            .fail(reject);
        });
      }

      function _addGiftItemsToCart() {
        if (!hasNonCxGiftItems || !freeGifts.length) {
          return;
        }

        console.log('MARCTEST ADD TO CART');

        cartChanged = true;

        const itemsToAdd = [];

        _.forEach(freeGifts, (giftItem) => {
          itemsToAdd.push({
            id: giftItem.variantId,
            quantity: giftItem.quantity,
            properties: {
              [FREE_GIFT_REDEMPTION_KEY_PROPERTY]: redemptionKey,
              [FREE_GIFT_MINIMUM_CART_TOTAL_PROPERTY]: giftItem.minimumCartTotal,
              [FREE_GIFT_MINIMUM_CART_FULL_PRICE_SIPS_COUNT_PROPERTY]: giftItem.minimumCartFullPriceSipsCount,
              [FREE_GIFT_TRACKING_PROPERTY]: giftItem.customerTrackingProperty,
            },
          });
        });

        return new Promise((resolve, reject) => {
          window.waitForCirkulServices.cart.then(() => {
            window.cirkulServices.cart.addToCartBulk(itemsToAdd, false, false, true)
              .then(resolve)
              .catch(reject);
          });
        });
      }

      function _checkCartNeedsUpdating() {
        const currentFreeGiftsCompare = _.reduce(freeGifts, (currentFreeGiftsCompare, freeGift) => {
          const giftUniqueKey = `${freeGift.variantId}:${freeGift.customerTrackingProperty}:${freeGift.minimumCartTotal}:${freeGift.minimumCartFullPriceSipsCount}`;
          //console.log('[checkCartNeedsUpdating] CURRENT giftUniqueKey', giftUniqueKey);
          currentFreeGiftsCompare[giftUniqueKey] = {
            quantity: freeGift.quantity,
            redemptionKey: redemptionKey,
          };

          return currentFreeGiftsCompare;
        }, {});
        const previousFreeGiftsCompare = _.reduce(previousCxGiftItems, (previousFreeGiftsCompare, cartItem) => {
          const giftUniqueKey = `${cartItem.variant_id}:${cartItem.properties[FREE_GIFT_TRACKING_PROPERTY]}:${cartItem.properties[FREE_GIFT_MINIMUM_CART_TOTAL_PROPERTY]}:${cartItem.properties[FREE_GIFT_MINIMUM_CART_FULL_PRICE_SIPS_COUNT_PROPERTY]}`;
          //console.log('[checkCartNeedsUpdating] PREVIOUS giftUniqueKey', giftUniqueKey);
          previousFreeGiftsCompare[giftUniqueKey] = {
            quantity: cartItem.quantity,
            redemptionKey: cartItem.properties[FREE_GIFT_REDEMPTION_KEY_PROPERTY] || null,
          };

          return previousFreeGiftsCompare;
        }, {});

        console.log('MARCTEST CHECK CART NEEDS UPDATING', currentFreeGiftsCompare, previousFreeGiftsCompare, !_.isEqual(currentFreeGiftsCompare, previousFreeGiftsCompare));


        return !_.isEqual(currentFreeGiftsCompare, previousFreeGiftsCompare);
      }
    }
  }

  function checkGiftCodeAppliedToCart(giftShortcode) {
    const giftCodeToFind = GIFT_CODES_MAP[giftShortcode]?.code;
    let isAppliedToCart = false;

    if (giftCodeToFind) {
      _.forEach(giftCodes, (giftCode) => {
        if (giftCode === giftCodeToFind) {
          isAppliedToCart = true;
        }
      });
    }

    return isAppliedToCart;
  }

  /**
   * Should be called immediately after payment is successful, to clean up validation, gift codes, etc...
   */
  function completeCheckout() {
    _clearFreeGiftValidationInterval();
  }

  function _clearFreeGiftValidationInterval() {
    clearInterval(freeGiftValidationInterval);
    freeGiftValidationInterval = null;
  }

  function _setCartGiftCodesAttribute(giftCodes) {
    window.waitForCirkulServices.cart.then(() => {
      try {
        window.cirkulServices.cart.setCartAttributes({ [GIFT_CODES_CART_ATTRIBUTE]: (giftCodes || []).join(',') })
        .then(() => { })
        .catch((err) => { }); // fail silently
      } catch(err)  {}
    });
  }

  function getParameterByName(name, url) {
    /* eslint-disable */
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
    /* eslint-enable */
  }
})();
